(function(){
  function wire(form){
    form.addEventListener('submit', function(){
      var typeSel = form.querySelector('[data-lc-type]');
      var stateSel = form.querySelector('[data-lc-state]');
      var countySel = form.querySelector('[data-lc-county]');
      var qInput = form.querySelector('input[name="q"]');
      if (!qInput) return;
      var parts = [];
      if (typeSel && typeSel.value) parts.push(typeSel.value);
      if (countySel && countySel.value) { parts.push(countySel.value); }
      else if (stateSel && stateSel.value) { parts.push(stateSel.value); }
      qInput.value = parts.join(' ');
    });
  }
  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.lc-find-form').forEach(wire);
  });
})();
